import { Component, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { version } from 'src/environments/environment';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-more',
    templateUrl: './more.component.html',
    styleUrls: ['./more.component.css'],
    standalone: false
})
export class MoreComponent {
[x: string]: any;
  private _usuarioService = inject(UsuarioService);
  private router = inject(Router);
  private _location = inject(Location);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);

  // ===== estado (signals) =====
  error = signal<string>('');
  dataUser: any;
  preview_img_avatar?: string;
  nombre?: string;
  id_perfil:number = 2; // USUARIO
  version: string = version;


  constructor(){
    this.id_perfil = this._usuarioService.usuario().id_perfil!;
  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();

      } catch (e: any) {
        console.error(e);
        this.error = e?.message || 'No se pudo cargar tu cuenta.';
        this.router.navigate(['/sign-in']);
      }
    });
  }
  
  logout(){
    this._authService.logout();
  }

  dashboard(){
    console.log(this.router);
    this.router.navigate(['/dashboard']);
  }

  back(){
    this._location.back();
  }

  openhelp(){
    var showvisible = document.getElementById('tooltip-pwa')!.style.display;
    if (showvisible == 'flex'){
      document.getElementById('tooltip-pwa')!.style.display = 'none';
    }else{
      switch(this.id_perfil){
        case 1:
          document.getElementById('helpinfo')!.textContent = 'INFO para el perfil 1';
          break;
        case 2:
          document.getElementById('helpinfo')!.textContent = 'Podrás encontrar los principales accesos a tu cuenta, tus compras y obtener ayuda';
          break;
        case 3:
          document.getElementById('helpinfo')!.textContent = 'INFO para el perfil 3';
          break;
        case 4:
          document.getElementById('helpinfo')!.textContent = 'INFO para el perfil 4';
          break;
        default:
          document.getElementById('helpinfo')!.textContent = 'INFO para el perfil 5';
          break;
        }
      
      document.getElementById('tooltip-pwa')!.style.display = 'flex';
    }
  }

}
